<script lang="ts">
  import CartWidgetGroupV2 from "@retailer/svelte/CartWidget/v2/CartWidgetGroupV2.svelte";
  import RequestItem from "@retailer/svelte/CartWidget/v2/middleware/RequestItem.svelte";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";
  import { CartWidgetTargetObjectBase } from "@shared/services/event_tracking/entities";
  import {
    sendCartTrackingEvents,
    sendClickTracking,
  } from "@retailer/svelte/CartWidget/v2/Services/CartEventTracking";
  import {
    shouldUseRetailerFulfillmentMethodForDistributor,
    hideFulfillmentMethodPickerForDistributor,
  } from "@retailer/services/fulfillment_methods_service";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import type { DistributorSummary } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";
  import type { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
  import type { RetailerFulfillmentMethod } from "@shared/types/RetailerFulfillmentMethod";

  export let inventoryId: number;
  export let trackingEntities: BaseEntityClass[] = [];
  export let loaded: boolean = false;

  const targetObjectTypeBase = CartWidgetTargetObjectBase.DealTiersPage;

  const trackCartChangeEvent = event => {
    sendCartTrackingEvents(event, trackingEntities, inventoryId);
  };

  const trackCartInteractionEvent = event => {
    sendClickTracking(targetObjectTypeBase, event, trackingEntities);
  };

  const hasFullfillmentMethodsRollout = stagedRolloutCheck("marketplace__fulfillment_methods");
  let fulfillmentMethod: RetailerFulfillmentMethod = null;
  let fulfillmentModel: string = null;
  let distributorSummary: DistributorSummary;
  let distributorSummaryId: number;

  $: cartWidgetItem = $InventoryItemStore?.inventoryItems[inventoryId];
  $: informationalNotices =
    cartWidgetItem?.notices.filter(notice => notice.level === "info" && notice.message) || [];
  $: distributorSummary = cartWidgetItem?.distributor_summary;
  $: distributorSummaryId = distributorSummary?.id;
  $: fulfillmentModel = cartWidgetItem?.distributor_summary?.fulfillment_model;
  $: {
    if (
      hideFulfillmentMethodPickerForDistributor(distributorSummaryId) &&
      fulfillmentModel === "pickup_only"
    ) {
      fulfillmentMethod = $RetailerFulfillmentMethodsStore[distributorSummaryId] || null;
    }
  }
  $: {
    if (
      shouldUseRetailerFulfillmentMethodForDistributor(
        distributorSummaryId,
        distributorSummary?.uses_warehouse_pickup,
        hasFullfillmentMethodsRollout && distributorSummary?.uses_wine_cellar,
      ) &&
      !hideFulfillmentMethodPickerForDistributor(distributorSummaryId)
    ) {
      fulfillmentMethod = $RetailerFulfillmentMethodsStore[distributorSummaryId] || null;
      InventoryItemStore.fetchInventoryItem(inventoryId);
    }
  }
  $: fulfillmentWarehouseId =
    fulfillmentMethod?.warehouse_id || cartWidgetItem?.distributor_summary?.default_warehouse_id;
</script>

<style>
  .container-div {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
</style>

{#if loaded && cartWidgetItem}
  <RequestItem {cartWidgetItem} {fulfillmentWarehouseId}>
    <div
      class="container-div fizz-inset-squish-12"
      data-testid="deals-cart-widget"
      slot="cart-widget"
    >
      <CartWidgetGroupV2
        widgetItem={cartWidgetItem}
        {fulfillmentMethod}
        {fulfillmentWarehouseId}
        on:cartWidgetChange={trackCartChangeEvent}
        on:updateQuantity={trackCartInteractionEvent}
      />
      {#each informationalNotices as notice}
        <span class="fizz-align-self-end fizz-inset-squish-12">{notice.message}</span>
      {/each}
    </div>
  </RequestItem>
{/if}
